import { ChevronsRightIcon } from 'lucide-react';
import * as React from 'react';

import { DimeButton } from '../DimeButton.js';
import { isExpandAllDisabled } from '../lib/is-expand-all-disabled.js';
import { NO_EXPANDABLE_ROWS_TOOLTIP } from '../lib/no-expandable-rows-tooltip.js';
import { cn } from '../lib/utils.js';
import { NestedExpandAllContext } from './NestedExpandAllContext.js';

/** The expander column's header: Expand/Collapse all above the row chevrons, or a screen-reader label when the table doesn't offer it. */
export function NestedTableExpandAllHeader() {
  const expandAll = React.useContext(NestedExpandAllContext);
  // An empty table header fails axe, so label it for screen readers only.
  if (!expandAll) return <span className="sr-only">Expand</span>;

  const { anyRowExpanded, hasExpandableRows, onExpandAll, onCollapseAll } = expandAll;
  const disabled = isExpandAllDisabled({ anyRowExpanded, hasExpandableRows });
  return (
    <DimeButton
      variant="ghost"
      size="icon"
      aria-label={anyRowExpanded ? 'Collapse all rows' : 'Expand all rows'}
      disabled={disabled}
      disabledTooltip={disabled ? NO_EXPANDABLE_ROWS_TOOLTIP : undefined}
      onClick={anyRowExpanded ? onCollapseAll : onExpandAll}
    >
      <ChevronsRightIcon className={cn('transition-transform', anyRowExpanded && 'rotate-90')} />
    </DimeButton>
  );
}
